import { IntlShape } from 'react-intl/src/types';
import {
  CalculatorsHomeValueFormFields,
  CalculatorsHomeValueStep1FormFields,
  CalculatorsHomeValueStep2FormFields,
  CalculatorsHomeValueStep3FormFields,
  CalculatorsHomeValueStep4FormFields
} from '../../../../../@types/features/calculators';
import {
  useCalculatorHomeValueStep1FormFields,
  useCalculatorHomeValueStep2FormFields,
  useCalculatorHomeValueStep3FormFields,
  useCalculatorHomeValueStep4FormFields
} from '../config';
import { ApiResidenceValuePropertyValueRequest } from '../../../../../@types';

const utilsHomeValueGetDefaultValuesStep1 = (
  intl: IntlShape
): CalculatorsHomeValueStep1FormFields => {
  const calculatorHomeValueStep1FormFields = useCalculatorHomeValueStep1FormFields(intl);
  return {
    postalCode: calculatorHomeValueStep1FormFields.postalCode.defaultValue,
    houseNumber: calculatorHomeValueStep1FormFields.houseNumber.defaultValue,
    houseNumberExt: calculatorHomeValueStep1FormFields.houseNumberExt.defaultValue
  };
};

const utilsHomeValueGetDefaultValuesStep2 = (
  intl: IntlShape
): CalculatorsHomeValueStep2FormFields => {
  const calculatorHomeValueStep2FormFields = useCalculatorHomeValueStep2FormFields(intl);
  return {
    residenceType: calculatorHomeValueStep2FormFields.fields.residenceType.defaultValue,
    maintenance: calculatorHomeValueStep2FormFields.fields.maintenance.defaultValue,
    energyLabel: calculatorHomeValueStep2FormFields.fields.energyLabel.defaultValue
  };
};

const utilsHomeValueGetDefaultValuesStep3 = (
  intl: IntlShape
): CalculatorsHomeValueStep3FormFields => {
  const calculatorHomeValueStep3FormFields = useCalculatorHomeValueStep3FormFields(intl);
  return {
    buildYear: calculatorHomeValueStep3FormFields.buildYear.defaultValue,
    useSurface: calculatorHomeValueStep3FormFields.useSurface.defaultValue,
    plotSize: calculatorHomeValueStep3FormFields.plotSize.defaultValue,
    volume: calculatorHomeValueStep3FormFields.volume.defaultValue
  };
};

const utilsHomeValueGetDefaultValuesStep4 = (
  intl: IntlShape
): CalculatorsHomeValueStep4FormFields => {
  const calculatorHomeValueStep4FormFields = useCalculatorHomeValueStep4FormFields(intl);
  return {
    propertyPlans: calculatorHomeValueStep4FormFields.propertyPlans.defaultValue
  };
};

const utilsHomeValueGetPostData = (
  values: CalculatorsHomeValueFormFields
): ApiResidenceValuePropertyValueRequest => {
  //console.log('values', values);
  return {
    postCode: values.postalCode,
    houseNumber: parseInt(values.houseNumber),
    houseNumberExt: values.houseNumberExt,
    type: values.residenceType,
    buildYear: parseInt(values.buildYear),
    volume: parseInt(values.volume),
    plotSize: values.plotSize ? parseInt(values.plotSize) : null,
    useSurface: parseInt(values.useSurface),
    energyLabel: values.energyLabel,
    maintenance: values.maintenance
  };
};

export {
  utilsHomeValueGetDefaultValuesStep1,
  utilsHomeValueGetDefaultValuesStep2,
  utilsHomeValueGetDefaultValuesStep3,
  utilsHomeValueGetDefaultValuesStep4,
  utilsHomeValueGetPostData
};
